<!-- src/views/HomeView.vue - CORRECTED VERSION -->
<template>
  <div class="home-view">
    <!-- Client Interface: Show landing page or search with project context -->
   <!-- Replace the client interface section in your HomeView.vue template with this: -->

<!-- Client Interface: Show landing page or search with project context -->
 <!-- Replace your client interface section in HomeView.vue template with this: -->

<!-- Client Interface: Show landing page or search with project context -->
 <!-- Replace your client interface section with this ultra-simple version: -->

<!-- Client Interface -->
<div v-if="userType === 'client'">
  <!-- Landing Page: Show when no project is selected (user chooses what to do) -->
  <ClientLandingPage 
    v-if="!selectedProject"
    @project-selected="handleProjectSelection"
    @notify="handleNotification"
  />
  
  <!-- Search Interface: Show when user has explicitly selected a project -->
  <div v-else class="client-search-view">
    <ProjectContext 
      :selectedProject="selectedProject"
      @view-details="showProjectDetails"
      @switch-project="switchProject"
    />
    <!-- <HotListControls 
    v-if="userType === 'agent' || userType === 'client'"
    :readOnly="userType === 'client'"
    @hot-list-activated="handleHotListActivated"
    @hot-list-cleared="handleHotListCleared"
    class="hot-list-section"
  /> -->
    <SearchSection 
      ref="searchSection"
      :projectContext="selectedProject"
      :userType="userType"
      @search-results="handleSearchResults" 
      @context-update="handleContextUpdate"
      @search-start="startSearch"
    />
    
    <CompactAnalysis 
      v-if="showRagAnalysis" 
      :show="showRagAnalysis" 
      :analysis="ragAnalysis"
      :analysisInFrench="ragAnalysisInFrench"
      :recommendedCandidates="ragRecommendedCandidates" 
      @close="hideRagAnalysis"
      class="analysis-panel"
    />
     
    <GallerySection 
      :currentSort="currentSort"
      :searchResults="searchResults" 

      :ragRecommendations="ragRecommendedCandidates"
      :isLoading="isLoading"
      :projectContext="selectedProject"
      @project-updated="$emit('project-updated', $event)"
      @project-completed="handleProjectCompleted"
      @sort-changed="handleSortChange"
      class="gallery-section"
    />
  </div>
</div>
    <!-- Agent Interface: Existing unchanged functionality -->
    <div v-else class="agent-interface">
       <!-- Show project banner if agent is in project context -->
       
<!-- <div v-if="selectedProject" class="agent-project-banner">
  <div class="banner-content">
    <div class="project-icon">
      <i class="fas fa-project-diagram"></i>
    </div>
    
    <div class="project-info">
      <div class="project-main">
        <span class="client-name">{{ selectedProject.client_name || 'Loading...' }}</span>
        <span class="project-name">{{ selectedProject.project_name || 'Loading...' }}</span>
      </div>
      <div class="project-meta">
        <span class="job-title">{{ selectedProject.job_title || '' }}</span>
        <span v-if="selectedProject.status" class="project-status">{{ selectedProject.status }}</span>
      </div>
    </div>
    
    <button @click="exitProjectContext" class="exit-btn">
      <i class="fas fa-times"></i>
      Exit Project View
    </button>
  </div>
</div> -->

<AgentProjectBar 
    :projectContext="selectedProject"
    @project-selected="handleAgentProjectSwitch"
    @exit-context="exitProjectContext"
  />

 <!-- 🔥 HOT LISTS - Add BEFORE SearchSection -->
<!-- 🔥 HOT LISTS - Show for BOTH agents and clients -->
<HotListControls 
  v-if="userType === 'agent' || userType === 'client'"
  :readOnly="userType === 'client'"
  @hot-list-activated="handleHotListActivated"
  @hot-list-cleared="handleHotListCleared"
  class="hot-list-section"
/>

<SearchSection 
 ref="searchSection"
 :userType="userType"
 @search-results="handleSearchResults" 
 @context-update="handleContextUpdate"
 @search-start="startSearch"
/>

    
      <CompactAnalysis 
        v-if="showRagAnalysis"
        :show="showRagAnalysis" 
        :analysis="ragAnalysis"
        :analysisInFrench="ragAnalysisInFrench"
        :recommendedCandidates="ragRecommendedCandidates" 
        @close="hideRagAnalysis"
        class="analysis-panel"
      />
      
      <GallerySection 
      
        :currentSort="currentSort"
        :searchResults="searchResults" 
        :ragRecommendations="ragRecommendedCandidates"
        :isLoading="isLoading"
        :projectContext="selectedProject"
        :activeHotListId="activeHotList"  
        :userType="userType" 
        @sort-changed="handleSortChange"
        @candidate-hidden="handleCandidateHidden"  


        class="gallery-section"
      />
    </div>
<!-- Espace Perso floating button (agents only) -->
<router-link v-if="userType === 'agent'" to="/history" class="perso-fab">
  <i class="fas fa-th-large"></i>
  <span>Mon Espace</span>
</router-link>
    <BackToTop />

    <!-- Loading overlay for user type detection -->
    <div v-if="detectingUserType" class="user-type-loading">
      <div class="loading-content">
        <div class="loading-spinner">
          <i class="fas fa-spinner fa-spin"></i>
        </div>
        <p>Setting up your workspace...</p>
      </div>
    </div>
  </div>
</template>

<script>
import BackToTop from "@/components/BackToTop.vue";
import SearchSection from "@/components/SearchSection.vue";
import GallerySection from "@/components/GallerySection.vue";
import CompactAnalysis from "@/components/RAGAnalysis.vue";
import ClientLandingPage from "@/components/ClientLandingPage.vue";
import ProjectContext from "@/components/ProjectContext.vue";
import HotListControls from '@/components/HotListControls.vue';
import { useProjectStore } from '@/store/projectContext'
import AgentProjectBar from '@/components/AgentProjectBar.vue';
import NLSearchTestPanel from '@/components/NLSearchTestPanel.vue';

import axios from 'axios';

export default {
  name: "HomeView",
  components: {
    BackToTop,
    SearchSection,
    GallerySection,
    CompactAnalysis,
    ClientLandingPage,
    ProjectContext,
    HotListControls,
    AgentProjectBar

  },
  //  setup() function - it runs before data() and lets us use Pinia
setup() {
  const projectStore = useProjectStore()
  
  // Expose store to Options API (so you can use this.projectStore in methods)
  return { projectStore }
},
  data() {
    return {
      currentSort: 'relevance',
      activeHotList: null,
    hotListCandidateIds: [],

      // clientHasProjects: false,  // Track if client has any projects
      // checkingClientProjects: false,
      // Existing data properties
      searchResults: { results: [], timestamp: Date.now() },
      isLoading: false,
      showRagAnalysis: false,
      ragAnalysis: '',
      ragAnalysisInFrench: '', 
      ragRecommendedCandidates: [],
      currentJobDescription: '',
      currentAdditionalContext: '',
      currentPreferences: [],
      
      // New user type and project data
      userType: null, // 'agent' or 'client'
      detectingUserType: true,
      selectedProject: null,
      contextInitialized: false, // Add this flag
      notifications: []

    };
  },
  async created() {
  console.log('🏁 HomeView created');
  
  // Detect user type first
  await this.detectUserType();
  
  // IMPORTANT: Check notification context BEFORE template renders
  if (this.userType === 'client') {
    await this.checkClientNotificationContextSync(); // New sync version
  }
  
  // // Load stored project for clients
  // if (this.userType === 'client') {
  //   this.loadProjectFromStorage();
  // }
  
  // Check if client has projects (for clients only)
  if (this.userType === 'client') {
    await this.checkClientProjects();
  }
  
  // Check agent project context (for agents only)
  if (this.userType === 'agent') {
    this.checkAgentProjectContext();
  }
  
  this.contextInitialized = true;
  console.log('✅ HomeView initialization complete');
},
  async mounted() {
  this.contextInitialized = false;
  await this.detectUserType();


  //    // Get user ID from auth service or API
  // const userInfo = await this.getUserInfo()  // You might already have this
  // const userId = userInfo?.sub || userInfo?.client_id || userInfo?.user_id
  // Get user ID - works for both agents and clients
  const userInfo = await this.getUserInfo();
  const userId = userInfo?.user_id || userInfo?.client_id || userInfo?.sub || userInfo?.email;
  
  console.log('🔑 Resolved userId for store:', userId);


  //    // NEW: Pass userId to init
  // this.projectStore.initFromStorage(userId)
  // if (this.projectStore.hasActiveProject) {
  //   this.selectedProject = this.projectStore.activeProject
  // }
  
    // Pass userId to init
    if (userId) {
    this.projectStore.initFromStorage(userId);
    if (this.projectStore.hasActiveProject) {
      this.selectedProject = this.projectStore.activeProject;
    }
  } else {
    console.warn('⚠️ No userId available - skipping storage restore');
  }

  //this.loadProjectFromStorage();
 
  this.checkAgentProjectContext();
  this.contextInitialized = true;
  console.log('✅ HomeView initialization complete');
  },
  
  methods: {
    async handleAgentProjectSwitch(project) {
  console.log('🔄 HomeView: Agent switching to project:', project.project_name);
  
  // Update local state
  this.selectedProject = {
    project_id: project.project_id,
    project_name: project.project_name,
    job_title: project.job_title,
    client_name: project.client_name,
    status: project.status
  };
  
  // Trigger search refresh if SearchSection is available
  if (this.$refs.searchSection) {
    // Clear current results and trigger fresh search
    this.searchResults = { results: [], timestamp: Date.now() };
    await this.$refs.searchSection.handleSearch();
  }
},
//     async getUserInfo() {
//   try {
//     const response = await axios.get('/api/v1/clients/profile')
//     console.log("🙈🙈🙈🙈🙈 bro's data is ",response.data)
//     return response.data
//   } catch {
//     // Fallback: try to get from auth service
//     return null
//   }
// },
async getUserInfo() {
  try {
    // First, try to get from Cognito directly (works for ALL user types)
    const { authService } = await import('@/services/auth.js');
    const cognitoUser = await authService.getCurrentUser();
    
    if (cognitoUser) {
      // Use Cognito's unique user ID (sub) - works for both agents and clients
      const userId = cognitoUser.userId || cognitoUser.attributes?.sub || cognitoUser.username;
      console.log('🔑 User ID from Cognito:', userId);
      return { user_id: userId, email: cognitoUser.attributes?.email };
    }
    
    // Fallback for clients: try API (this will 403 for agents, which is fine)
    if (this.userType === 'client') {
      const response = await axios.get('/api/v1/clients/profile');
      console.log("🔑 User ID from client profile:", response.data.client_id);
      return response.data;
    }
    
    return null;
  } catch (error) {
    console.warn('⚠️ getUserInfo error (may be expected for agents):', error.message);
    return null;
  }
},
    handleCandidateHidden(candidateId) {
      console.log('🙈 Candidate hidden:', candidateId);
      
      // Remove from current results (optimistic update)
      if (this.searchResults?.results) {
        this.searchResults.results = this.searchResults.results.filter(
          r => {
            const id = r._source?.metadata?.candidate_id || r.candidate_id;
            return id !== candidateId;
          }
        );
      }
      
      // Update hot list candidate count
      if (this.$refs.hotListControls) {
        this.$refs.hotListControls.decrementCandidateCount();
      }
    },
    async checkClientNotificationContextSync() {
  const projectId = this.$route.query.project_id;
  const fromNotification = this.$route.query.from === 'notification';
  
  if (projectId && fromNotification) {
    console.log('🎯 Client notification context detected (sync):', { projectId });
    
    // Load the project synchronously before template renders
    await this.loadClientProjectFromNotification(projectId);
  }
},
    // FIX: Handle project completion
  handleProjectCompleted(project) {
    console.log('🎉 Project completed:', project.project_name);
    // Clear the selected project
    this.selectedProject = null;
    this.clearProjectFromStorage();
  },
  async autoSelectFirstProject() {
  try {
    console.log('🔄 HomeView: Auto-selecting first project for seamless experience');
    
    const response = await axios.get('/api/v1/clients/projects');
    const projects = response.data || [];
    
    if (projects.length > 0) {
      const firstProject = projects[0];
      // NEW: Use store instead of saveProjectToStorage
      this.projectStore.setProject(firstProject);
      this.selectedProject = firstProject;
      console.log('✅ HomeView: Auto-selected first project:', firstProject.project_name);
    }
    
  } catch (error) {
    console.error('❌ HomeView: Error auto-selecting project:', error);
  }
},
    async handleProjectCreated() {
    console.log('🎉 HomeView: Client created a project - refreshing project status');
    
    // Refresh the client projects check
    await this.checkClientProjects();
    
    // If client now has projects, they can start selecting projects
    if (this.clientHasProjects) {
      console.log('✅ HomeView: Client now has projects - they can access search functionality');
    }
  },
    // NEW: Check if client has projects
  async checkClientProjects() {
    if (this.userType !== 'client') {
      return; // Only applies to clients
    }
    
    try {
      this.checkingClientProjects = true;
      console.log('🔍 HomeView: Checking if client has projects...');
      
      const response = await axios.get('/api/v1/clients/projects');
      const projects = response.data || [];
      
      this.clientHasProjects = projects.length > 0;
      
      console.log(`📊 HomeView: Client has ${projects.length} projects`);
      
      // PROTECTION: If client has no projects and somehow has a selectedProject, clear it
      if (!this.clientHasProjects && this.selectedProject) {
        console.log('⚠️ HomeView: Client has no projects but selectedProject exists - clearing it');
        this.selectedProject = null;
        this.clearProjectFromStorage();
      }
      
    } catch (error) {
      console.error('❌ HomeView: Error checking client projects:', error);
      // On error, assume no projects for safety
      this.clientHasProjects = false;
      if (this.selectedProject) {
        this.selectedProject = null;
        this.clearProjectFromStorage();
      }
    } finally {
      this.checkingClientProjects = false;
    }
  },
    exitProjectContext() {
      console.log('🚪 HomeView: Exiting project context');

      // NEW: Clear via store
  this.projectStore.clearProject()

  this.selectedProject = null;
  this.$router.replace({ query: {} });

  // Remove query parameters
  //this.$router.push({ path: '/', query: {} });
},

// Add this new method in HomeView.vue
checkClientNotificationContext() {
  if (this.userType !== 'client') return;
  
  const projectId = this.$route.query.project_id;
  const fromNotification = this.$route.query.from === 'notification';
  
  if (projectId && fromNotification) {
    console.log('🎯 Client notification context detected:', { projectId });
    
    // For clients, we need to find the project in their projects list
    // and set it as selectedProject so they skip the landing page
    this.loadClientProjectFromNotification(projectId);
  }
},

// Add this method too
async loadClientProjectFromNotification(projectId) {
  try {
    const response = await axios.get('/api/v1/clients/projects');
    const projects = response.data || [];
    
    const project = projects.find(p => p.project_id === projectId);
    if (project) {
      // NEW: Use store instead of saveProjectToStorage
      this.projectStore.setProject(project);
      this.selectedProject = project;
      console.log('✅ Client project context set from notification:', project.project_name);
    } else {
      console.warn('⚠️ Project not found in client projects:', projectId);
    }
  } catch (error) {
    console.error('❌ Error loading client project from notification:', error);
  }
},


checkAgentProjectContext() {
  // IMPORTANT: Only apply this logic to agents, not clients
  if (this.userType === 'client') {
    return; // Exit early for clients - they use their own project selection logic
  } 
  
  const projectId = this.$route.query.project_id;
  const hasProjectContext = this.$route.query.project_context === 'true';
  //const fromNotification = this.$route.query.from === 'notification';
  const fromNotification = ['notification', 'agent_dashboard'].includes(this.$route.query.from);


  // Trigger project context if:
  // 1. Explicit project_context=true (existing behavior)
  // 2. OR coming from notification with project_id (NEW)
  if (projectId && (hasProjectContext || fromNotification) && this.userType === 'agent') {
    console.log('🎯 Agent project context detected:', { 
      projectId, 
      hasProjectContext, 
      fromNotification,
      source: fromNotification ? 'notification' : 'explicit' 
    });
    // Load project details with client name and project name
    this.loadProjectDetails(projectId);
    // Set project context for agent
    // this.selectedProject = {
    //   project_id: projectId
    // };
    
    // No need to manually trigger search - SearchSection.vue will auto-handle 
    // the candidate_id parameter from the route query
  } else if (!projectId && !hasProjectContext && !fromNotification) {
    // Clear project context if no relevant query params
    if (this.selectedProject) {
      console.log('🗑️ Clearing project context - no relevant query params');
      this.selectedProject = null;
    }
  }
},

async loadProjectDetails(projectId) {
  try {
    // Fetch project details including client name
    const response = await axios.get(`/api/v1/projects/${projectId}/details`);
    
    // Build project object with full details
    const project = {
      project_id: projectId,
      project_name: response.data.project_name,
      job_title: response.data.job_title,
      client_name: response.data.company_name,
      status: response.data.status
    };
    
    // NEW: Use store for agents too
    this.projectStore.setProject(project);
    this.selectedProject = project;
    
    console.log('✅ Agent project context set with details:', this.selectedProject);
    
  } catch (error) {
    console.error('Error loading project details:', error);
    
    // Fallback: Set basic project context with just ID
    const fallbackProject = {
      project_id: projectId,
      project_name: 'Loading...',
      client_name: 'Loading...'
    };
    
    this.projectStore.setProject(fallbackProject);
    this.selectedProject = fallbackProject;
    
    console.log('⚠️ Using fallback project context:', this.selectedProject);
  }
},
    // Existing methods (keep unchanged)
    startSearch() {
      this.isLoading = true;
    },
    
    handleContextUpdate(context) {
      this.currentJobDescription = context.jobDescription || '';
      this.currentAdditionalContext = context.additionalContext || '';
      this.currentPreferences = context.preferences || [];
    },
    handleSortChange(sortValue) {
      console.log('🎯 HomeView: Received sort-changed event:', sortValue);
      
      // Update current sort state
      this.currentSort = sortValue;
      
      // Get reference to SearchSection
      const searchSection = this.$refs.searchSection;
      
      if (!searchSection) {
        console.error('❌ HomeView: SearchSection ref not found!');
        console.log('Available refs:', Object.keys(this.$refs));
        return;
      }
      
      console.log('✅ HomeView: Found SearchSection ref');
      
      // Update SearchSection's sort
      searchSection.selectedSort = sortValue;
      console.log('📝 HomeView: Updated SearchSection.selectedSort to:', sortValue);
      
      // Trigger new search
      console.log('🔍 HomeView: Calling SearchSection.handleSearch()');
      searchSection.handleSearch();
    },
    handleSearchResults(results) {
      this.isLoading = false;
      
      if (results && results.timestamp) {
        if (results.searchType === 'rag') {
          this.ragAnalysis = results.analysis || '';
          this.ragAnalysisInFrench = results.analysisInFrench || results.analysis || '';
          this.ragRecommendedCandidates = results.recommendedCandidates || [];
          this.showRagAnalysis = true;
          
          this.searchResults = {
            results: results.results || [],
            timestamp: results.timestamp
          };
        } else {
          this.searchResults = results;
          this.hideRagAnalysis();
          // Update sort state if provided in results
          if (results.sortBy) {
            this.currentSort = results.sortBy;
            console.log('🔄 HomeView: Updated currentSort from results:', results.sortBy);
          }
        }
      } else if (Array.isArray(results)) {
        this.searchResults = {
          results: results,
          timestamp: Date.now()
        };
        this.hideRagAnalysis();
      }
    },
    
    hideRagAnalysis() {
      this.showRagAnalysis = false;
      this.ragAnalysis = '';
      this.ragAnalysisInFrench = '';
      this.ragRecommendedCandidates = [];
    },
    
    // New user type detection methods
    async detectUserType() {
      try {
        this.detectingUserType = true;
        
        const response = await axios.get('/api/v1/clients/user/type');
        this.userType = response.data.user_type;
        
        console.log('User type detected:', this.userType);
        
      } catch (error) {
        console.warn('User type detection failed, defaulting to agent:', error);
        this.userType = 'agent'; // Default to agent interface
      } finally {
        this.detectingUserType = false;
      }
    },
    
    // Project management methods
   // ENHANCED: Project selection with protection
   handleProjectSelection(project) {
    console.log('🔵 VERIFY: handleProjectSelection called with:', project.project_name);
  console.log('🔵 VERIFY: Store hasActiveProject BEFORE:', this.projectStore.hasActiveProject);
  
  // This should trigger store
  this.projectStore.setProject(project);
  
  console.log('🔵 VERIFY: Store hasActiveProject AFTER:', this.projectStore.hasActiveProject);
  console.log('🔵 VERIFY: Store projectId:', this.projectStore.projectId);
  
  this.selectedProject = project;
  },
  
  // ENHANCED: Switch project with protection
  switchProject() {
    console.log('🔄 HomeView: User switching projects');
    // NEW: Clear via store (triggers isTransitioning briefly)
    this.projectStore.clearProject()
    
    this.selectedProject = null;
    //this.clearProjectFromStorage();
  },
 
    
    showProjectDetails(project) {
      // You can implement a modal or navigate to a details view
      console.log('Show project details:', project);
    },
    
    // Local storage helpers for project persistence
   // Keep these simple storage helpers
  //  saveProjectToStorage(project) {
  //   localStorage.setItem('selectedProject', JSON.stringify(project));
  // },
  
  // loadProjectFromStorage() {
  //   const stored = localStorage.getItem('selectedProject');
  //   if (stored) {
  //     try {
  //       this.selectedProject = JSON.parse(stored);
  //       console.log('📁 HomeView: Loaded project from storage:', this.selectedProject?.project_name);
  //     } catch (e) {
  //       console.warn('Failed to parse stored project:', e);
  //       localStorage.removeItem('selectedProject');
  //     }
  //   }
  // },
  
  clearProjectFromStorage() {
    localStorage.removeItem('selectedProject');
  },
    
    // Notification handling
    handleNotification(notification) {
      // You can implement toast notifications or other UI feedback
      console.log('Notification:', notification);
      this.notifications.push(notification);
      
      // Auto-remove after 5 seconds
      setTimeout(() => {
        const index = this.notifications.indexOf(notification);
        if (index > -1) {
          this.notifications.splice(index, 1);
        }
      }, 5000);
    },
  
  
  
handleHotListActivated(hotListData) {
  console.log('🔥 Hot list activated in HomeView:', hotListData.name, hotListData.candidate_ids.length);
  
  this.activeHotList = hotListData.hot_list_id;
  this.hotListCandidateIds = hotListData.candidate_ids;
  
  // Pass to SearchSection
  if (this.$refs.searchSection) {
    this.$refs.searchSection.activateHotList(hotListData);
  }
},

handleHotListCleared() {
  console.log('🚫 Hot list cleared in HomeView');
  
  this.activeHotList = null;
  this.hotListCandidateIds = [];
  
  // Clear from SearchSection
  if (this.$refs.searchSection) {
    this.$refs.searchSection.clearHotList();
  }
},

  },

// Watch for route changes to handle agent project context
watch: {
  
  '$route'(to, from) {
    if (!this.contextInitialized) return;

    if (to.query.project_id !== from.query.project_id) {
      this.checkAgentProjectContext();
      this.checkClientNotificationContext(); // NEW client logic

    }

    // NEW: Protect clients without projects from accessing search via URL manipulation
    if (this.userType === 'client' && !this.clientHasProjects) {
      // Clear any selectedProject if client somehow gets one through URL manipulation
      if (this.selectedProject) {
        console.log('⚠️ HomeView: Clearing selectedProject - client has no projects');
        this.selectedProject = null;
        this.clearProjectFromStorage();
      }
    }
  },
  
  // NEW: Watch for when projects are created (after ClientLandingPage emits project creation)
  async userType(newType) {
    if (!this.contextInitialized) return;

    if (newType === 'client') {
      await this.checkClientProjects();
    }
  },
  projectContext: {
    handler(newContext, oldContext) {
      if (!this.contextInitialized) {
        // Ignore changes during initial setup
        return;
      }
      
      console.log('🎯 HomeView: Project context change:', {
        from: oldContext?.project_id || 'null',
        to: newContext?.project_id || 'null'
      });
    },
    deep: false
  }
}
};
</script>

<style scoped>
.home-view {
  min-height: 100vh;
}

.client-search-view {
  /* Container for client search interface with project context */
}

.agent-interface {
  /* Container for agent interface (existing styling) */
}

.user-type-loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.user-type-loading .loading-content {
  text-align: center;
  color: white;
}

.user-type-loading .loading-spinner {
  font-size: 2rem;
  margin-bottom: 1rem;
}


/* CSS PROJECT BANNER */

.agent-project-banner {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 1.25rem 0;
  margin-bottom: 2rem;
  border-radius: 0.75rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  border-left: 4px solid #4f46e5;
}

.banner-content {
  max-width: 1900px;
  margin: 0 auto;
  padding: 0 1rem;
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.project-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 50%;
  backdrop-filter: blur(4px);
}

.project-icon i {
  font-size: 1.25rem;
  color: white;
}

.project-info {
  flex: 1;
  min-width: 0; /* Allow text truncation */
}

.project-main {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.25rem;
}

.client-name {
  font-size: 1.125rem;
  font-weight: 700;
  color: white;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.project-name {
  font-size: 1rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
  position: relative;
}

.project-name::before {
  content: "•";
  margin-right: 0.75rem;
  color: rgba(255, 255, 255, 0.6);
}

.project-meta {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 0.875rem;
  color: rgba(255, 255, 255, 0.8);
}

.job-title {
  font-style: italic;
}

.project-status {
  background: rgba(255, 255, 255, 0.2);
  padding: 0.125rem 0.5rem;
  border-radius: 0.75rem;
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.exit-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
  padding: 0.75rem 1.25rem;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  backdrop-filter: blur(4px);
  flex-shrink: 0;
}

.exit-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.exit-btn i {
  font-size: 0.875rem;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .banner-content {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }
  
  .project-main {
    flex-direction: column;
    gap: 0.25rem;
  }
  
  .project-name::before {
    display: none;
  }
  
  .project-meta {
    justify-content: center;
    gap: 0.75rem;
  }
  
  .exit-btn {
    align-self: stretch;
    justify-content: center;
  }
}

 

/* Updated container - reduced padding for more horizontal space */
.container {
  max-width: 1400px; /* Increased from 1200px */
  margin: 0 auto;
  padding: 0 1rem; /* Reduced from 0 2rem */
}

/* Responsive breakpoints - maintain padding on smaller screens */
@media screen and (max-width: 768px) {
  .container {
    padding: 0 1rem; /* Keep existing mobile padding */
  }
}


 
.hot-list-section {
  margin-bottom: 1.5rem;
}
.perso-fab {
  position: fixed;
  bottom: 24px;
  right: 24px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: var(--surface-color);
  border: 1px solid var(--border-color);
  border-radius: 40px;
  color: var(--text-color);
  text-decoration: none;
  font-size: 0.8rem;
  font-weight: 700;
  box-shadow: 0 4px 20px rgba(0,0,0,0.15);
  z-index: 900;
  transition: all 0.2s;
}
.perso-fab i { color: #93c5fd; font-size: 0.85rem; }
.perso-fab:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 28px rgba(0,0,0,0.25);
  border-color: rgba(59,130,246,0.3);
}
.perso-fab span { white-space: nowrap; }
</style>